import IsLoading from './loading';

export default IsLoading;